const baseStyle = {
  link: {},
}

const defaultProps = {
  variant: 'default',
}

const parts = ['container', 'column', 'content', 'heading', 'link', 'row', 'section', 'trademark']

const sizes = {}

const variants = {
  default: {
    container: {
      bg: 'darkBlue.main',
      color: 'white',
    },
    link: {
      color: 'white',
    },
  },
  developer: {
    container: {
      bg: 'darkBlue.main',
      color: 'white',
    },

    link: {
      color: 'digiGreen.main',
    },
  },
  light: {
    container: {
      bg: 'white',
      color: 'darkBlue.main',
    },
    row: {
      color: 'black',
    },

    link: {
      color: 'seaBlue.main',
    },
    heading: {
      color: 'darkBlue.main',
    },
  },
}

export default {
  baseStyle,
  defaultProps,
  parts,
  sizes,
  variants,
}
